import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {DeliveriesDialogService} from "../../services/deliveries-dialog-service.service";

export class DeliveryAgentCommentIndicationCtrl implements IController {
  service: any;

  private showIndication: any;

  /* @ngInject */
  constructor(private deliveriesDialogService: DeliveriesDialogService) {
  }

  $onInit() {
    this.showIndication = !!_.find(this.service.taskList, (t) => {
      return !!(t.agentComment || _.get(t, 'freePictureUrls.length'))
    })
  }

  $onChanges(changes) {
    if (changes.service && !changes.service.isFirstChange()) {
      this.$onInit();
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  open(delivery, event) {
    event.stopPropagation();
    this.deliveriesDialogService.serviceInfo(delivery, event);
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveryAgentCommentIndication', {
    bindings: {
      service: '<'
    },
    template: require('./delivery-agent-comment-indication.html').default,
    controller: DeliveryAgentCommentIndicationCtrl
  });
